
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/terms/data",
      function () {
        return require("private-next-pages/profile/terms/data.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/terms/data"])
      });
    }
  